import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comment"
export default class extends Controller {
  connect() {
    // Check if this is a newly added comment
    if (this.element.classList.contains("comment--new")) {
      // Scroll to the comment with a slight delay to ensure DOM is ready
      this.element.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })

      // Remove the new comment highlight after scrolling
      setTimeout(() => {
        this.element.classList.remove("comment--new")
      }, 3000)
    }
  }
}
